import { render, staticRenderFns } from "./PromoCodesList.vue?vue&type=template&id=2bd8a850&"
import script from "./PromoCodesList.vue?vue&type=script&lang=js&"
export * from "./PromoCodesList.vue?vue&type=script&lang=js&"
import style0 from "./PromoCodesList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports